<template>
  <div>お探しのページは見つかりませんでした。</div>
</template>

<script>
export default {};
</script>

<style></style>
